import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import { Link } from 'react-router-dom';
import { useStateValue } from '../StateProvider';
import { getAuth, signOut } from "firebase/auth";
import { actionTypes } from '../reducer';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { getFirestore, collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, InputAdornment } from '@mui/material';
import { Collapse, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NavRepartidor from './repartidor/NavRepartidor';
import NavbarClient from './navbarClient';
// import { Grid } from '@mui/material';
// import Product from './product';
// import logo from '../assets/AllFresco.png';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: 'solid',
  borderColor: 'black',
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const Nav1 = styled('div')(({ theme }) => ({
  backgroundColor: '#43ABAE',
  height: '40px',
  maxHeight: '40px'
}));

export default function Navbar({ userType }) {



  const [{ basket, user, product, notification, category }, dispatch] = useStateValue();
  const [busqueda, setBusqueda] = React.useState("");
  const [productos, setProductos] = React.useState([])
  const [showInputSearch, setShowInputSearch] = React.useState(false)
  const db = getFirestore()
  const [showDialogConfirmRecibed, setShowDialogConfirmRecibed] = React.useState(false)
  const [showAlertConfirmRecibed, setShowAlertConfirmRecibed] = React.useState(false)
  const [categoriesSearched, setCategoriesSearched] = React.useState([])
  const handleChange = e => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  }
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  const filtrar = (terminoBusqueda) => {
    let productMatched = false
    var resultadosBusqueda = product.filter((elemento) => {
      if (elemento.name != undefined && removeAccents(elemento.name.toString().toLowerCase()).includes(removeAccents(terminoBusqueda.toLowerCase()))) {
        // console.log(elemento)
        return elemento;
      }
      // elemento.tags.map( (tag)=>{
      //   if(tag.toLowerCase().includes(terminoBusqueda.toLowerCase()))
      //   productMatched=true
      // }
      // )
      if (productMatched) return elemento
    })
    const result = category.filter(c => c.label !== undefined && removeAccents(c.label.toString().toLowerCase()).includes(removeAccents(terminoBusqueda.toLowerCase())))
    if (result) {
      setCategoriesSearched(result)
    }
    setProductos(resultadosBusqueda);
    if (terminoBusqueda != '') {
      // document.getElementById('inicio').style.display = "none";
      document.getElementById('filtro').style.display = "flex";
    } else {
      // document.getElementById('inicio').style.display = "block";
      document.getElementById('filtro').style.display = "none";
      setProductos([])
    }
  }
  const history = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleAuth = () => {
    if (user) {
      const auth = getAuth();
      signOut(auth).then(() => {
        dispatch({
          type: actionTypes.EMPTY_BASKET,
          basket: [],
        });
        dispatch({
          type: actionTypes.SET_USER,
          user: null,
        });
        setAnchorEl(null);
        handleMobileMenuClose();
        history("/");
      }).catch((error) => {
        console.log(error);
      });
    }
    setAnchorEl(null)
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Link to='signin'>
        <MenuItem onClick={handleAuth} sx={{ '&:hover': { background: "white" } }}> <Button variant='contained' fullWidth sx={{ fontWeight: "bold", borderRadius: "10px" }} >{user ? "Salir" : "Iniciar sesión"}</Button> </MenuItem>
      </Link>
      {
        user ? <Link to='perfil'>
          <MenuItem onClick={handleMenuClose}>{user ? user.email : 'Invitado'}</MenuItem>
        </Link> : (<Link to='signin'>
          <MenuItem onClick={handleMenuClose} sx={{ '&:hover': { background: "white" } }} > <Button variant='contained' sx={{ fontWeight: "bold", borderRadius: "10px" }} fullWidth >Registrarse</Button> </MenuItem>
        </Link>)
      }
    </Menu>
  );

  const getPendingOrders = async () => {
    const res = await getDoc(doc(db, 'orders', user.uid))
    // console.log("----------Pending orders -------------")
    // console.log(res.data().orders)
    if (!res.exists()) {
      return
    }
    const result = Object.entries(res.data().orders).find(o => o[1].statusOrder == "entregado")
    if (result) {
      setShowDialogConfirmRecibed(true)
      dispatch({
        type: actionTypes.SET_NOTIFYCATION,
        notification: result
      })
    }
    // console.log(result)
    // res.find( o => o.statusOrder == 'entregado ' )
    // if() if faltaPorConfirmarCompra => showAlert
    //else nothing
  }
  const handleCancel = () => {
    //if cancel 
    //diplay notifcation
  }

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const [openCp, setOpenCp] = React.useState(true);
  const [cpvalue, setCpvalue] = React.useState("")
  React.useEffect(() => {
    const zipcode = localStorage.getItem("cpvalue")
    if (zipcode) {
      setCpvalue(zipcode)
      setOpenCp(false)
    }

  }, [])
  React.useEffect(() => {
    if (user?.uid) {
      getPendingOrders()
    }

  }, [user])

  React.useEffect(() => {
    localStorage.setItem("cpvalue", cpvalue)

  }, [cpvalue])


  const handleClickOpen = () => {
    setOpenCp(true);
  };

  const handleClose = () => {
    setOpenCp(false);
    setOpenAlert(false)
  };
  const [isDelivery, setIsDelivery] = React.useState(false)
  const consultar = async () => {
    let cobertura = false
    try {
      const docRef = collection(db, 'cp')
      const datos = await getDocs(docRef)
      datos.forEach(doc => {
        // console.log(doc.data().cp + ' => ' + cpvalue)
        if (doc.data().cp === cpvalue) {
          cobertura = true
          // console.log(true)
        }
      })
      if (cobertura) {
        // alert("Constamos con envio en su zona: " + cpvalue)
        setIsDelivery(true)
        setTimeout(() => setOpenCp(false), 1000)
      }
      else
        setIsDelivery(false)
      // console.log("Por el momento no contamos con cobertura en su zona")
      // setOpenCp(false)
      setOpenAlert(true)
    } catch (error) {
      console.log("Error al consultar: ", error)
    }
  }
  const handleConsultar = (valuecp) => {
    if (valuecp.length <= 5)
      setCpvalue(valuecp)
  }
  const [openAlert, setOpenAlert] = React.useState(false);

  if (userType === "empacador" || userType === "repartidor") {
    return <NavRepartidor role={userType === "empacador" ? "Empacador" : "Repartidor"} />
  }

  return (
    <div className="header">
      <Box className="navbar">
        <AppBar position="static" sx={{}}>

          <Nav1 className='at-top'>
            <div className='sub-header'>
              <Typography className='promo' >
                ¡Envío gratis en compras mínimas de 600 MXN!
              </Typography>
            </div>
          </Nav1>

          <Toolbar className='at-middle' >
            <div className='sub-header'>
              <div className='at-left'>
                <Link to='/' >
                  <Typography className='logo' variant="h2">
                    allfresco
                  </Typography>
                </Link>
                <div className='zip-box'>
                  <Typography className='zip-code' display={{ xs: "none", md: "block" }} >
                    Enviar:
                  </Typography>
                  <Button onClick={() => handleClickOpen(true)} sx={{ padding: 0 }} >
                    <Typography variant="h5" >
                      {cpvalue !== "" ? cpvalue : "CP"}
                    </Typography>
                  </Button>
                </div>
              </div>
              <div className='at-center'>
                {/* <IconButton */}
                <Button
                  sx={{ display: { xs: "block", sm: "none" } }}
                  // startIcon={<SearchIcon />} 
                  onClick={() => {
                    setShowInputSearch(!showInputSearch)
                    setBusqueda("")
                    document.getElementById('filtro').style.display = "none";
                  }}  >
                  <span className='icon-Busqueda-allfresco' ></span>
                </Button>
                {/* </IconButton> */}
                <Search className='search-box'  >
                  <SearchIconWrapper display={{ xs: "none", sm: "block" }} >
                    <SearchIcon className='search-icon' />
                  </SearchIconWrapper>
                  <StyledInputBase className='search-input'
                    placeholder="Buscar..."
                    inputProps={{ 'aria-label': 'search' }}
                    value={busqueda}
                    onChange={handleChange}
                    onBlur={() => setTimeout(function () { setBusqueda(""); setShowInputSearch(false); document.getElementById('filtro').style.display = "none"; }, 1000)}

                    display="block"
                    sx={showInputSearch ? { display: { xs: "block" }, width: { xs: "50vw" }, position: { xs: "fixed" }, top: { xs: "96" } } : { display: { xs: "none", sm: "block" } }}
                  />
                </Search>
              </div>
              {/* <Box /> */}
              <div className='at-right'>
                <Box className="user-box">
                  <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                    sx={{ display: { xs: 'none', sm: "block", md: 'flex', marginRight: "10px" } }}
                  >
                    {/* <AccountCircle /> */}
                    {
                      user ? (<Box sx={{
                        backgroundImage: `url(${user.photoURL})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                      }} ></Box>) : (
                        <span className='icon-Perfil-de-usuario-allfresco' sx={{ color: "#B6D33C", marginLeft: "5px" }} ></span>
                      )
                    }
                    {!user && <Typography sx={{ margin: 'auto' }} className='user-box-text' >Invitado</Typography>}
                  </IconButton>
                  {user && <Typography sx={{ margin: 'auto' }} className='user-box-text' >{user.displayName}</Typography>}
                  {/* <Typography sx={{ margin: 'auto' }} className='user-box-text' >
                    {user ? user.displayName : 'Invitado'}
                  </Typography> */}
                  <Link to='/checkout'>
                    <IconButton
                      size="large"
                      edge="end"
                      aria-label="account of current user"
                      aria-controls={menuId}
                      aria-haspopup="true"
                      color="inherit"
                    >
                      <Badge badgeContent={basket.length} color="secondary">
                        {/* <ShoppingBag /> */}
                        <label className="icon-canasta-allfresco" ></label>
                      </Badge>
                    </IconButton>
                  </Link>

                </Box>
                <Box sx={{ display: { xs: 'none', md: 'none' } }} >
                  <IconButton
                    size="large"
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <MoreIcon />
                  </IconButton>
                </Box>

              </div>
            </div>
          </Toolbar>

        </AppBar>
      </Box>
      <div className="mobile-menu">
        {renderMobileMenu}
        {renderMenu}
        <Box id="filtro" spacing={2} top="115px" position="fixed" flexDirection="column"
          sx={showInputSearch ? { backgroundColor: "#fff", width: "90%", margin: "auto", left: "5%", right: "auto" } : { backgroundColor: "#fff", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px", width: "60%", display: { xs: busqueda === "" ? "none" : "block" }, left: "20%" }} p={2}
        >
          {
            productos.map((item) => {
              let url = ""
              if (busqueda === "")
                return null
              else {
                url = "/" + item.category + "/" + item.id
                return <Box  >
                  <Link to={url} onClick={() => {
                    document.getElementById('filtro').style.display = "none";
                    setBusqueda("")
                    setShowInputSearch(false)
                  }}>
                    <MenuItem value={10} p={2}> {item.name}  </MenuItem>
                  </Link>
                  <hr></hr>
                </Box>
              }
            }
            )
          }
          {
            busqueda === ""
              ? null
              : categoriesSearched.map(cat => {
                // console.log("cat => ",cat)
                return <Box  >
                  <Link to={`/${removeAccents(cat.value)}`} onClick={() => {
                    document.getElementById('filtro').style.display = "none";
                    setBusqueda("")
                    setShowInputSearch(false)
                  }}>
                    <MenuItem value={10} p={2}> {cat.label}  </MenuItem>
                  </Link>
                  <hr></hr>
                </Box>
              })
          }
        </Box>
      </div>
      <Dialog open={openCp} onClose={() => handleClose()}  >
        <Box sx={{
          backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/allfresco-52e3c.appspot.com/o/assets%2Fallfresco-background-zip-code.webp?alt=media&token=861aa892-3360-4759-8a0e-989a34dfde00)`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          width: "auto",
          height: "auto"
        }} p={1} >
          <DialogTitle display={"flex"} justifyContent="center" >allfresco
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: "24px",
                top: "24px",
                backgroundColor: "#D30000",
                color: "white",
                height: "24px",
                width: "24px",
                '&:hover': {
                  background: "red"
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ width: { xs: "100%", md: "50%" } }} >
            <DialogContentText color="secondary"  >
              Introduce tu codigo postal, para saber la disponibilidad en tu zona.
            </DialogContentText>
            <TextField
              size='small'
              autoFocus
              margin="dense"
              id="name"
              type="number"
              fullWidth
              variant="filled"
              value={cpvalue}
              onChange={(e) => handleConsultar(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  consultar()
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start' >
                    <span className='icon-Busqueda-allfresco' ></span>
                  </InputAdornment>
                )
              }}
              sx={{
                background: "#fff",
                marginTop: "20px",
                paddingTop: "6px"
              }}

            />
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "flex-start", width: { xs: "100%", md: "50%" }, marginX: "15px" }} >
            {/* <Button onClick={handleClose}>Cerrar</Button> */}
            <Button sx={{ borderRadius: "10px", textTransform: "none", fontWeight: "bold", fontSize: "1.2rem", fontFamily: "Quicksand", paddingX: "25px" }} onClick={() => consultar()} variant="contained" >Consultar y guardar</Button>
          </DialogActions>
          <Collapse in={openAlert}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={
                    handleClose
                  }
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
              severity={isDelivery ? "success" : "error"}
            >
              {isDelivery ? "Contamos con envío en tu zona. Bienvenido a allfresco" : "Lo sentimos, por el momento no contamos con envío en tu zona, aun así puedes continuar navegando por el sitio."}
            </Alert>
          </Collapse>
        </Box>
      </Dialog>
      <Dialog open={showDialogConfirmRecibed} sx={{ borderRadius: '20px' }} >
        <Box sx={{
          backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/allfresco-52e3c.appspot.com/o/categories%2Fmoras.webp?alt=media&token=71c1d998-18ca-4050-a3cf-7e04522d4d99)',
          backgroundPositionY: 'center',
          backgroundSize: 'cover',
          maxWidth: '452px',
          width: '100%',
          minWidth: '400px',
          maxHeight: '310px',
          height: '260px',
          display: 'flex',
        }} >
          <div style={{ width: '50%' }} ></div>
          <div style={{ width: '50%', padding: '1em', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} >
            <button style={{
              width: '20px',
              height: '20px',
              background: '#d30000',
              color: 'white',
              borderRadius: '50%',
              border: 'none',
              position: 'relative',
              top: '-10px',
              right: '-90px',
            }}
              onClick={() => {
                setShowDialogConfirmRecibed(false)
                setShowAlertConfirmRecibed(true)

              }}
            >x</button>
            <Typography variant='h2' sx={{ marginY: '1em' }} >allfresco</Typography>
            <Typography variant='body1' sx={{ color: "#ceb19b", textAlign: 'center', fontSize: { md: '18px', xs: '12px !important' } }} >Tu pedido ha sido entregado</Typography>
            <Link to={"/perfil"} >
              <Button variant='contained' sx={{ marginY: '2em' }} >Confirmar</Button>
            </Link>
          </div>
        </Box>
      </Dialog>
      {
        showAlertConfirmRecibed && notification !== null ?
          <Box sx={{
            position: 'absolute',
            top: '50px',
            left: '20px',
            maxWidth: '600px',
            zIndex: 999999999,
            background: "#f77400",
            display: 'flex',
            alignItems: 'center',
            padding: '1em',
            borderRadius: '10px',
            marginRight: '20px'
          }}

          >
            <div style={{ fontWeight: 'bold' }} >
              <svg xmlns="http://www.w3.org/2000/svg" width="43.328" height="43.492" viewBox="0 0 43.328 43.492">
                <defs>
                  <clipPath id="clip-path">
                    <rect id="Rectángulo_1424" data-name="Rectángulo 1424" width="43.328" height="43.492" fill="none" />
                  </clipPath>
                </defs>
                <g id="Grupo_3097" data-name="Grupo 3097" clipPath="url(#clip-path)">
                  <path id="Trazado_2140" data-name="Trazado 2140" d="M37.674,36.354c-.316,1.927-1.34,2.8-3.381,2.837-1.824.033-3.649-.025-5.473.017-1.09.025-2.176.163-3.3.253,0,1.143.021,2.165-.014,3.184a1.036,1.036,0,0,1-.324.712.692.692,0,0,1-1.08-.626c-.02-.756-.006-1.513-.006-2.27,0-.162,0-.323,0-.55-.251.079-.455.14-.66.207-2.909.958-5.809,1.945-8.732,2.861a7.676,7.676,0,0,1-3.469.363,6.7,6.7,0,0,1-3.883-2.258c-.088-.094-.178-.188-.348-.367v1.672c0,.728-.194,1-.7,1s-.72-.3-.717-1.043c.005-1.215,0-2.43,0-3.685-.395-.056-.843-.118-1.29-.186a1,1,0,0,1-.8-.61C2.369,35.586,1.2,33.323.106,31.021A1.918,1.918,0,0,1,.131,29.7a9.749,9.749,0,0,1,1.063-2.233A24.9,24.9,0,0,1,3.37,24.777c.857-.94,1.791-1.809,2.682-2.7-.471-.846-.452-.974.221-1.647l2.285-2.278a10.1,10.1,0,0,1-.783-1.293A2.873,2.873,0,0,0,6.25,15.21c-1.349-.627-1.707-2.6-.9-4.067.064-.116.137-.226.227-.374a2.575,2.575,0,0,1-.634-2.043c.025-.9.006-1.81.006-2.715A5.022,5.022,0,0,1,8.412.856a12.252,12.252,0,0,1,7-.6A5.4,5.4,0,0,1,19.724,4.5c.041.157.073.317.119.516.84,0,1.683,0,2.527,0a3.594,3.594,0,0,1,3.386,2.118,2.387,2.387,0,0,1-.819,3.245,5.992,5.992,0,0,1-2.832.956c-.47.056-.944.078-1.457.119-.154,2.626-.368,5.259-2.282,7.4a15.505,15.505,0,0,0,1.871,1.817,6.034,6.034,0,0,0,1.8.533v-.528c0-1.365,0-2.73,0-4.1,0-.658.223-.88.882-.88q9.79,0,19.58,0c.676,0,.822.157.822.846q0,9.369,0,18.738c0,.925-.15,1.071-1.09,1.071H37.674m4.275-1.437V17.144H36.284V18.8c0,1.068.006,2.137,0,3.2-.006.712-.463.982-1.085.664-.7-.357-1.4-.72-2.111-1.043a.816.816,0,0,0-.6.012c-.7.318-1.384.676-2.073,1.02-.767.382-1.245.1-1.248-.759,0-1.247,0-2.493,0-3.739v-1H23.485V33.485l.235-.052a17.071,17.071,0,0,1,2.772-.6c1.79-.1,3.589-.054,5.383-.023A2.023,2.023,0,0,1,33.8,34.486c.029.142.063.282.1.431ZM7.165,23.038c-.989.988-1.963,1.922-2.891,2.9a15.531,15.531,0,0,0-1.68,2.008,14.852,14.852,0,0,0-1.117,2.2.834.834,0,0,0,.052.624q1.481,3.084,3,6.148a.637.637,0,0,0,.368.315A4.1,4.1,0,0,0,9.626,34.8a.77.77,0,0,0-.052-.819c-.6-.938-1.17-1.89-1.737-2.846a.713.713,0,0,1,.475-1.158c.4-.065.623.184.806.5C10,32,10.881,33.532,11.779,35.049a2.692,2.692,0,0,0,3.254,1.235c2.181-.712,4.355-1.448,6.535-2.161.26-.085.364-.217.325-.478a.366.366,0,0,1,0-.044c0-3.5,0-7,.008-10.5,0-.33-.1-.478-.419-.53a8.073,8.073,0,0,1-1.037-.245c-.249-.075-.37-.01-.477.228-.273.607-.574,1.2-.867,1.8-.374.763-.96.821-1.457.147-.335-.454-.666-.91-1-1.363-.064-.086-.146-.159-.246-.267-.315.8-.585,1.552-.917,2.279a.788.788,0,0,1-.548.41,1.18,1.18,0,0,1-.664-.318c-.114-.089-.15-.283-.212-.433-.276-.664-.548-1.329-.845-2.053l-1.887,2.4c-.511.651-.8.682-1.425.162-.9-.751-1.8-1.5-2.735-2.282M32.389,34.93c-.076-.523-.284-.709-.8-.711-1.438,0-2.876-.023-4.314.008a9.307,9.307,0,0,0-1.8.23c-.735.163-1.46.385-2.176.621-2.544.837-5.079,1.7-7.627,2.534a4.15,4.15,0,0,1-4.7-1.421.94.94,0,0,1-.1-.171,15.041,15.041,0,0,1-1.62,1.608A14.158,14.158,0,0,1,7.3,38.659a8.424,8.424,0,0,0,2.067,2.348A7.257,7.257,0,0,0,10.5,41.7a4.845,4.845,0,0,0,3.69.024c2.927-.9,5.836-1.859,8.739-2.835a17.9,17.9,0,0,1,5.905-1.117c1.765.018,3.529.031,5.294,0a4.9,4.9,0,0,0,1.419-.3,1.1,1.1,0,0,0,.723-1.04c-.174,0-.332,0-.489,0q-2.535-.036-5.07-.073c-.549-.008-.83-.252-.834-.706s.283-.71.822-.715c.562-.006,1.123,0,1.689,0m-13.5-26.47-.123-.029c-.13.175-.254.357-.392.526a16.429,16.429,0,0,1-1.147,1.353,3.769,3.769,0,0,1-2.8,1.126c-2.357-.038-4.714-.017-7.071,0a.9.9,0,0,0-.632.214,1.837,1.837,0,0,0-.243,1.772,1.192,1.192,0,0,0,1.15.834,1.057,1.057,0,0,1,1,.84,8.228,8.228,0,0,0,.908,1.867,4.938,4.938,0,0,0,4.594,2.27,4.774,4.774,0,0,0,4.356-3.2,12.235,12.235,0,0,0,.663-5.641c-.05-.646-.169-1.287-.257-1.93m-8.234-6.72a6.334,6.334,0,0,0-2.8,1.048,3.01,3.01,0,0,0-1.4,2.275c-.081,1.448-.07,2.9-.047,4.354a.743.743,0,0,0,.473.538c1.133.127,2.271.168,3.108-.835.312-.375.628-.749.917-1.142,1.391-1.9,3.117-3.148,5.613-2.971.614.044,1.234.007,2,.007a12.5,12.5,0,0,0-.851-1.7,3.934,3.934,0,0,0-3.6-1.742A3.364,3.364,0,0,0,11.033,3.91a9.521,9.521,0,0,0-.38,1.815.746.746,0,0,1-.759.711A.675.675,0,0,1,9.228,5.7a4.668,4.668,0,0,1,.037-.621,6.373,6.373,0,0,1,1.387-3.337M11.2,10c1.137,0,2.2-.021,3.27.008A2.037,2.037,0,0,0,15.945,9.5a16,16,0,0,0,1.132-1.185c.467-.514.92-1.042,1.387-1.557a1.662,1.662,0,0,1,.305-.212l-.084-.109c-.87,0-1.743.029-2.613-.008a3.841,3.841,0,0,0-2.438.8A11.521,11.521,0,0,0,11.2,10m19.4,7.141V20.95a10.922,10.922,0,0,0,1.332-.666,1.312,1.312,0,0,1,1.595.013,14.275,14.275,0,0,0,1.3.65v-3.8ZM20.6,10.035a13.772,13.772,0,0,0,1.811-.2,8.055,8.055,0,0,0,1.763-.663.811.811,0,0,0,.422-1.06,2.409,2.409,0,0,0-1.7-1.609,3.578,3.578,0,0,0-2.707.72c-.065.04-.095.207-.077.3.149.81.313,1.618.488,2.509M12.425,21.54c-1-.663-1.973-1.308-2.951-1.944a.3.3,0,0,0-.268-.015c-.612.592-1.213,1.2-1.834,1.816l3.134,2.561,1.919-2.418m5.106-1.409c-.067.183-.148.383-.211.588s-.2.458-.129.577c.338.538.739,1.036,1.15,1.59l.669-1.276-1.479-1.479m-1.617.255-2.029.329,1.066,2.264c.338-.911.645-1.737.964-2.593" transform="translate(0 0)" fill="#fff" />
                </g>
              </svg>

            </div>
            <Link to="/perfil" >
              <div style={{ color: 'white', marginLeft: '1em' }} >
                <span style={{ marginLeft: '5px' }} >!Hola¡</span>
                <p style={{ color: 'white', margin: '5px' }} >Aun tienes un pedido por confirmar de recibido</p>
              </div>
            </Link>
          </Box>
          : null
      }

      {userType === "cliente" && (
        <>
          {/* <Box sx={{ height: { xs: "90px", sm: "120px", md: "180px" }, background: "#000" }} ></Box> */}
          <NavbarClient />
        </>
      )}

    </div>
  );
}